export const images = [
  require("../img/map_bg.jpg"),
  require("../img/map.png"),
  require("../img/map_intro.png"),
  require("../img/road_oj_btn.png"),
  require("../img/road_zd_btn.png"),
  require("../img/road_qt_btn.png"),

  require("../img/address_ca.png"),
  require("../img/address_cn.png"),
  require("../img/address_cs.png"),
  require("../img/address_jn.png"),
  require("../img/address_js.png"),
  require("../img/address_jy.png"),
  require("../img/address_kc.png"),
  require("../img/address_kh.png"),
  require("../img/address_ld.png"),
  require("../img/address_lq.png"),
  require("../img/address_ly.png"),
  require("../img/address_pa.png"),
  require("../img/address_py.png"),
  require("../img/address_qj.png"),
  require("../img/address_qt.png"),
  require("../img/address_qy.png"),
  require("../img/address_sc.png"),
  require("../img/address_sm.png"),
  require("../img/address_sy.png"),
  require("../img/address_ts.png"),
  require("../img/address_tt.png"),
  require("../img/address_wc.png"),
  require("../img/address_wy.png"),
  require("../img/address_xj.png"),
  require("../img/address_yh.png"),
  require("../img/address_yj.png"),

  require("../img/data_ca.png"),
  require("../img/data_cn.png"),
  require("../img/data_cs.png"),
  require("../img/data_jn.png"),
  require("../img/data_js.png"),
  require("../img/data_jy.png"),
  require("../img/data_kc.png"),
  require("../img/data_kh.png"),
  require("../img/data_ld.png"),
  require("../img/data_lq.png"),
  require("../img/data_ly.png"),
  require("../img/data_pa.png"),
  require("../img/data_py.png"),
  require("../img/data_qj.png"),
  require("../img/data_qt.png"),
  require("../img/data_qy.png"),
  require("../img/data_sc.png"),
  require("../img/data_sm.png"),
  require("../img/data_sy.png"),
  require("../img/data_ts.png"),
  require("../img/data_tt.png"),
  require("../img/data_wc.png"),
  require("../img/data_wy.png"),
  require("../img/data_xj.png"),
  require("../img/data_yh.png"),
  require("../img/data_yj.png"),

  require("../img/data_moun_ca.png"),
  require("../img/data_moun_cn.png"),
  require("../img/data_moun_cs.png"),
  require("../img/data_moun_jn.png"),
  require("../img/data_moun_js.png"),
  require("../img/data_moun_jy.png"),
  require("../img/data_moun_kc.png"),
  require("../img/data_moun_kh.png"),
  require("../img/data_moun_ld.png"),
  require("../img/data_moun_lq.png"),
  require("../img/data_moun_ly.png"),
  require("../img/data_moun_pa.png"),
  require("../img/data_moun_py.png"),
  require("../img/data_moun_qj.png"),
  require("../img/data_moun_qt.png"),
  require("../img/data_moun_qy.png"),
  require("../img/data_moun_sc.png"),
  require("../img/data_moun_sm.png"),
  require("../img/data_moun_sy.png"),
  require("../img/data_moun_ts.png"),
  require("../img/data_moun_tt.png"),
  require("../img/data_moun_wc.png"),
  require("../img/data_moun_wy.png"),
  require("../img/data_moun_xj.png"),
  require("../img/data_moun_yh.png"),
  require("../img/data_moun_yj.png"),

  require("../img/nor_cn_moun1.png"),
  require("../img/nor_cn_moun2.png"),
  require("../img/nor_jn_moun1.png"),
  require("../img/nor_jn_moun2.png"),
  require("../img/nor_jy_moun1.png"),
  require("../img/nor_ld_moun1.png"),
  require("../img/nor_lq_moun1.png"),
  require("../img/nor_lq_moun2.png"),
  require("../img/nor_py_moun1.png"),
  require("../img/nor_qt_moun1.png"),
  require("../img/nor_qy_moun1.png"),
  require("../img/nor_sc_moun1.png"),
  require("../img/nor_sm_moun1.png"),
  require("../img/nor_sm_moun2.png"),
  require("../img/nor_sy_moun1.png"),
  require("../img/nor_sy_moun2.png"),
  require("../img/nor_ts_moun1.png"),
  require("../img/nor_tt_moun1.png"),
  require("../img/nor_tt_moun2.png"),
  require("../img/nor_wc_moun1.png"),
  require("../img/nor_xj_moun1.png"),
  require("../img/nor_xj_moun2.png"),
  require("../img/nor_yh_moun1.png"),
  require("../img/nor_yj_moun1.png"),

  require("../img/icon_gdp_xj.png"),
  require("../img/house.png")
];
